import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Heading,
  BlockQuote,
  // Link,
  List,
  Image,
  ImageToolbar,
  ImageUpload,
  ImageResize,
  Base64UploadAdapter,
  Table,
  CodeBlock,
} from "ckeditor5";
import { toast } from "react-toastify";

const CKeditorComponent = ({ onChange, tag, value }) => {
  const [editorData, setEditorData] = useState("");
  
  useEffect(() => {
    setEditorData(value ? value : "");
  }, [value]);

  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        data={editorData}
        config={{
          toolbar: {
            items: [
              "heading",
              "|",
              "bold",
              "italic",
              // "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
              "insertTable",
              "undo",
              "redo",
              "|",
              "codeBlock",
              "imageUpload",
            ],
          },
          plugins: [
            Bold,
            Essentials,
            Italic,
            Mention,
            Paragraph,
            Undo,
            Heading,
            BlockQuote,
            // Link,
            List,
            Image,
            ImageToolbar,
            ImageUpload,
            ImageResize,
            Base64UploadAdapter,
            Table,
            CodeBlock,
          ],
          licenseKey: "<YOUR_LICENSE_KEY>",
        }}
        onChange={(event, editor) => {
          let data = editor.getData();
          if (data.length > 1950) {
            toast.error(`Maximum limit of ${1950} characters reached.`);
            return;
          } else {
            setEditorData(data);
            onChange(data, tag);
          }
        }}
      />
    </div>
  );
};

export default CKeditorComponent;
